/**
 * Polyfill stable language features. These imports will be optimized by `@babel/preset-env`.
 *
 * See: https://github.com/zloirock/core-js#babel
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { Buffer } from 'buffer';

// Set "global" to window object
if (!('global' in window)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).global = window;
}

// Set "Buffer" to window object
if (!('Buffer' in window)) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).Buffer = Buffer;
}
